import { Component, computed, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { LpRidMechanicConfig } from '../../../../typings/schema';
import { getRidMechanic, RID_MECHANIC_CATEGORIES } from '../../../mechanics/rid-mechanic-registry';

/** The whole card is the button, in the color of the mechanic's category. Once finished it turns green, with the icon still in the category color, and can't be started again. */
@Component({
  selector: 'rid-stop-assignment',
  imports: [FaIconComponent],
  templateUrl: './rid-stop-assignment.html',
  host: {
    class: 'block',
    '[style.--category-color]': 'categoryColor()',
  },
})
export class RidStopAssignment {
  config = input.required<LpRidMechanicConfig>();
  finished = input.required<boolean>();

  clicked = output<void>();

  protected readonly faCheck = faCheck;

  protected readonly mechanic = computed(() => getRidMechanic(this.config()));
  protected readonly categoryColor = computed(() => RID_MECHANIC_CATEGORIES[this.mechanic().category].color);
  protected readonly name = computed(() => {
    const config = this.config();
    const name = 'name' in config ? config.name?.trim() : undefined;
    return name || this.mechanic().name;
  });
  protected readonly details = computed(() => this.mechanic().details(this.config()));
  /** The topics that will come up, one entry per AND-group; the topics within a group are alternatives. */
  protected readonly topics = computed(() => {
    const topicFilters = this.mechanic().topicFilters(this.config());
    const filter = topicFilters?.filters[topicFilters.index];
    if (!filter) return [];

    return filter.groups
      .map((group) => group.strings.map((s) => s.string.trim()).filter((topic) => topic && topic !== '*'))
      .filter((topics) => topics.length > 0)
      .map((topics) => topics.map(capitalize).join(' of '));
  });

  protected onClick() {
    if (!this.finished()) this.clicked.emit();
  }
}

function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
